import { cameraApiRequest } from './cameraApiRequest';

/**
 * A clip's MP4, signed for about 10 minutes: `{ url, thumbnailUrl?,
 * expiresAt }`. The API logs VIEW_CAMERA_RECORDING; with `download` the URL
 * is an attachment and it logs DOWNLOAD_CAMERA_RECORDING instead.
 */
export const getCameraClipUrl = ({
  projectId,
  cameraId,
  clipId,
  download = false,
  activeEmployerInfo,
}) =>
  cameraApiRequest({
    method: 'GET',
    apiPath: `projects/${projectId}/cameras/${cameraId}/clips/${clipId}/url${
      download ? '?download=1' : ''
    }`,
    activeEmployerInfo,
  });
